import { AppRegistry } from 'react-native';
import App from '../App';
import appJson from '../app.json';

const appName = appJson.name;

AppRegistry.registerComponent(appName, () => App);
AppRegistry.runApplication(appName, {
  rootTag: document.getElementById('root'),
});

// Register the Workbox service worker only in the production build (GenerateSW
// emits /service-worker.js). Keeps the installed PWA shell available offline.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  // If a service worker was already controlling this page, a new one taking
  // over means a deploy happened — reload once so the fresh bundle runs
  // immediately instead of after a second manual refresh.
  const hadController = !!navigator.serviceWorker.controller;
  let reloaded = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloaded || !hadController) return;
    reloaded = true;
    window.location.reload();
  });
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((reg) => { if (reg && reg.update) reg.update(); })
      .catch(() => { /* offline shell is a nice-to-have; ignore failures */ });
  });
}
